import { Menu, MenuItemProps } from 'semantic-ui-react';
import { useLocation } from 'react-router-dom';
import { buildUrl, AppRoutes } from '../../AppRoutes';
import { Link } from 'react-router-dom';

interface NavProps {
    className?: string;
}

export const Nav: React.FC<NavProps> = ({ className }) => {
    const location = useLocation();

    const isActive = (path: string): boolean => {
        return window.location.pathname.toLowerCase() === path.toLowerCase();
    };

    const menuItems: Array<{ name: string; path: string; label: string }> = [
        { name: 'profile', path: buildUrl(AppRoutes.ManageProfile, {}), label: 'Profile' },
        // { name: 'email', path: buildUrl(Routes.ManageEmail, {}), label: 'Email' },
        { name: 'changePassword', path: buildUrl(AppRoutes.ManageChangePassword, {}), label: 'Password' },
        { name: 'twoFactor', path: buildUrl(AppRoutes.ManageTwoFactor, {}), label: 'Two-factor authentication' },
        // { name: 'personalData', path: buildUrl(Routes.ManagePersonalData, {}), label: 'Personal data' },
    ];

    return (
        <Menu className={className} vertical fluid tabular>
            {menuItems.map((item) => (
                <Menu.Item
                    key={item.name}
                    name={item.name}
                    active={isActive(item.path)}
                    as={Link}
                    to={item.path}>
                    {item.label}
                </Menu.Item>
            ))}
        </Menu>
    );
};